import { useTranslations } from '@vocab/react';
import { Card, Stack, Text, Toggle } from 'braid-design-system';
import { useId } from 'react';

import type { Role } from 'src/__generated__/graphql';
import { CareerHistoryEditor } from 'src/components/CareerHistory/CareerHistoryEditor';

import translations from './.vocab';

interface Props {
  isNewToWorkforce: boolean;
  onNewToWorkforceToggle: (toggle: boolean) => void;
  roles: Role[];
  unconfirmedRoles?: Role[];
}

export function FirstRoleForm({
  isNewToWorkforce,
  onNewToWorkforceToggle,
  roles,
  unconfirmedRoles = [],
}: Props) {
  const { t } = useTranslations(translations);
  const formId = useId();

  return (
    <Stack space="medium">
      <Text tone="secondary">{t('Tell employers about your experience')}</Text>
      <Toggle
        id={`newToWorkforce-${formId}`}
        on={isNewToWorkforce}
        label={t('I am new to the workforce')}
        onChange={onNewToWorkforceToggle}
      />
      {!isNewToWorkforce && (
        <Card data={{ automation: 'no-career-history-form' }}>
          <CareerHistoryEditor
            unconfirmedRoles={unconfirmedRoles}
            roles={roles}
            shouldCloseDrawerOnExit
          />
        </Card>
      )}
    </Stack>
  );
}
